import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40d44794"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_2 = { class: "col-12 p-5" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger mb-3"
}
const _hoisted_4 = { class: "success-bg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "success-bg" }, " Your Sprinklr Authentication was SUCCESSFUL. Please hang on while we redirect you to the payment portal. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin fa-fw fa-2x" })
], -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin fa-fw fa-2x" })
], -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    success: true,
    title: _ctx.ready ? 'Register' : 'Please wait',
    onConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.purchase())),
    "cancel-button": false,
    "min-width": "800px",
    "max-width": "800px"
  }, {
    default: _withCtx(() => [
      (_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("h6", _hoisted_4, " Hi " + _toDisplayString(_ctx.name) + ",", 1),
              _hoisted_5,
              _hoisted_6
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
    ]),
    _: 1
  }, 8, ["title"]))
}